// OAuth相關翻譯

export const oauth = {
    processingGoogleLogin: 'Processing Google login...',
    redirecting: 'Redirecting...'
  };
